import { SettingsLayout } from "features/settings/SettingsLayout";
import i18n from "i18n/config";
import { RouteObject } from "react-router-dom";

export const settingsRoutes: RouteObject = {
  id: "settings",
  path: "settings",
  element: <SettingsLayout />,
  children: [
    {
      id: "users",
      path: "",
      lazy: async () => {
        const { UsersPage } = await import("features/settings/users/UsersPage");
        return { Component: UsersPage };
      },
      handle: {
        title: i18n.t("common:users"),
      },
    },
  ],
};
